const routes = [
  {
    path: '/documentPDF',
    name: '',
    redirect:'/documentPDF/list'
  },
  {
    path: '/documentPDF/list',
    name: '',
    meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档中心',keepAlive: true, breadcrumb:['documentPDF'],menuBreadcrumb: 'documentPDF',},//menu 用于所属右侧菜单栏
    component: () => import('@/views/documentPDF/index.vue')
  },
  {
    path: '/documentPDF/navManage',
    name: '',
    meta:{module:'operate_manage',menu:'/documentPDF/list',title:'导航管理',breadcrumb:['documentPDF','navManage'],menuBreadcrumb: 'navManage',},//menu 用于所属右侧菜单栏
    component: () => import('@/views/documentPDF/navManage.vue')
  },
  // {
  //   path: '/documentPDF/detail',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档详情'},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/detail.vue')
  // },
  // {
  //   path: '/documentPDF/add',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'新增文档',breadcrumb:['documentPDF','add'],menuBreadcrumb: 'add',},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/add.vue')
  // },
  // {
  //   path: '/documentPDF/edit',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'编辑文档',breadcrumb:['documentPDF','edit'],menuBreadcrumb: 'edit',},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/edit.vue')
  // },
  // {
  //   path: '/documentPDF/record',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档记录'},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/record.vue')
  // },
  // {
  //   path: '/documentPDF/audit',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档审核',breadcrumb:['documentPDF','audit'],menuBreadcrumb: 'audit',},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/audit.vue')
  // },
  // {
  //   path: '/documentPDF/contrast',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档对比'},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/contrast.vue')
  // },
  // {
  //   path: '/documentPDF/update',
  //   name: '',
  //   meta:{module:'operate_manage',menu:'/documentPDF/list',title:'文档更新',breadcrumb:['documentPDF','update'],menuBreadcrumb: 'update',},//menu 用于所属右侧菜单栏
  //   component: () => import('@/views/documentPDF/template/update.vue')
  // },
]
  
  export default routes;
    